<script setup lang="ts">
defineEmits(['click-link']);
defineProps<{
  message: string;
  link?: string;
}>();
</script>
<template>
  <div class="rounded-md bg-blue-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <ui-icon class="h-5 w-5 text-blue-400" name="Info" />
      </div>
      <div class="ml-3 flex-1 md:flex md:justify-between">
        <p class="text-sm text-blue-700">{{ message }}</p>
        <div v-if="link" class="mt-3 text-sm md:ml-6 md:mt-0">
          <p class="whitespace-nowrap cursor-pointer font-semibold text-blue-700 hover:text-blue-600" @click="$emit('click-link')">
            {{ link }}
            <span aria-hidden="true"> &rarr;</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
